import Overlay from 'ol/Overlay';

export const createOverlay = (name, htmlElement) => {
  const overlay = new Overlay({
    id: name,
    element: htmlElement,
  });

  return overlay;
};

export const removeOverlayIfExists = (map, overlay) => {
  const overlayId = overlay.getId();
  const overlayToRemove = map.getOverlayById(overlayId);

  if (overlayToRemove) map.removeOverlay(overlayToRemove);
};
